<template>
  <div class="generator">
    <div class="container-fluid">
      <div class="row text-center">
        <div class="insult col-12 d-none d-md-block">
          {{ insult.compound }}
        </div>
        <div class="insult col-12 d-block d-md-none">
          {{ insult.hyphenated }}
        </div>
      </div>
      <div class="row text-center">
        <div class="col-12 d-none d-sm-block">
          <button class="btn btn-outline-dark btn-lg" type="button" @click="getInsult(); updateButtonText()">{{ currentButtonText }}</button>
        </div>
        <div class="col-12 d-block d-sm-none">
          <button class="btn btn-outline-dark" type="button" @click="getInsult(); updateButtonText()">{{ currentButtonText }}</button>
        </div>
      </div>
    </div>

    <router-link class="btn btn-outline-dark btn-lg btn-nav" :to="{name: 'background'}">Hintergrund</router-link>
  </div>
</template>

<script>
import axios from 'axios';
export default {
  name: 'Generator',

  data() {
    return {
      buttonTexts: [
        "Alter, wie hast du mich genannt?",
        "Was willst du, Lan?",
        "Willst du aufs Maul oder was?",
        "Deine Mutter!",
        "Hol ich meine Brüder, Junge!",
        "Digger, komm mal klar!",
        "Hast du mich angeguckt?",
        "Also das is mir jetzt doch ein bisschen zu primitiv.",
        "Geht's noch?",
        "Ach komm, geh fott"
      ],
      currentButtonText: null,
      insult: {}
    }
  },

  methods:  {
    updateButtonText() {
      this.currentButtonText = this.buttonTexts[Math.floor(Math.random() * this.buttonTexts.length)]
    },

    getInsult() {
      axios.get('https://zdqpbfz4fk.execute-api.eu-central-1.amazonaws.com/default/hurenfickwurst')
      .then(response => (this.insult = response.data))
    }
  },

  // Fetches insult when the component is created.
  mounted() {
    this.updateButtonText()
    this.getInsult()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
</style>
